import React, { Component } from 'react';
import {
    Input,
    Label,
    Col,
    FormGroup,
    Form,
    Button
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import _ from 'lodash';
import './CommissionDetails.css';
import PropTypes from 'prop-types';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import { Utils } from "../../../utils/utils";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";

const requiredSelectFields = ['baId', 'continent', 'countries'];
const fields = ['baId','continent', 'countries', 'commission', 'dateFrom', 'dateTo'];

export const ACTION_TYPES = {
    ADD: 'add',
    EDIT: 'edit'
};


class CommissionDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            baId: '',
            continent: '',
            countries: [],
            commission: '',
            dateFrom: null,
            dateTo: null,
            requiredFieldError: null
        }
    }

    componentWillMount() {
        this.props.onGetBAsList();

        if (this.props.actionType === ACTION_TYPES.EDIT && !_.isNil(this.props.id) && !_.isNil(this.props.baId)) {
            this.props.onGetCommissionData(this.props.baId, this.props.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.actionType === ACTION_TYPES.ADD && !this.props.success && nextProps.success) {
            this.resetData();
        }

        if (nextProps.actionType === ACTION_TYPES.EDIT && _.isNil(this.props.data) && !_.isNil(nextProps.data)) {
            this.setState({
                baId: nextProps.data.baId,
                continent: nextProps.data.continent,
                countries: nextProps.data.countries,
                commission: nextProps.data.commission,
                dateFrom: moment(nextProps.data.dateFrom),
                dateTo: moment(nextProps.data.dateTo)
            })
            this.props.onSetContinent(nextProps.data.continent);
        }

        if (this.state.continent !== nextProps.currentContinent) {
            this.setState({ continent: nextProps.currentContinent })
        }
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    render() {
        if (this.props.success || (this.props.actionType === ACTION_TYPES.EDIT && _.isNil(this.props.id))) {
            return <Redirect to='/commissions'/>;
        }

        return (
            <div className='commission-container'>
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'commissions.' + this.props.actionType + '_commission_success_message')}
                >
                    <BackButtonComponent path='/commissions' label={_.get(this.props.translation, sharedLabelsPath.back_button)} />
                    <div className='commission-form'>
                        <h4 className='page-label'>
                            {_.get(this.props.translation, 'commissions.' + this.props.actionType + '_commission_label')}
                        </h4>
                        {
                            this.props.actionType === ACTION_TYPES.ADD ?
                                <h6 className="add-commission-hint">{Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'commissions.add_commission_hint'))}</h6>
                                : null
                        }
                        {this.renderContent()}
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading || _.isNil(this.props.BAsList)) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }

        return (
            <Form className='commission-from' onSubmit={this.handleSubmit}>
                {this.renderBAsFormGroup()}
                {this.renderContinentAndCountriesFormGroups()}
                {this.renderCommissionFormGroup()}
                {this.renderPeriodFormGroups()}
                <div className='button-group'>
                    <Button type="submit" className="olive-green-btn" disabled={this.saveButtonDisabled()}>
                        {_.get(this.props.translation, this.props.actionType === ACTION_TYPES.ADD ? sharedLabelsPath.add_button : sharedLabelsPath.save_changes_button)}
                    </Button>
                </div>
            </Form>
        )
    };

    renderBAsFormGroup = () => {
        if (this.props.actionType === ACTION_TYPES.ADD) {
            let options = Utils.getBAsOptions(this.props.BAsList);
            return (
                <FormGroup row>
                    <Label sm={4}>{_.get(this.props.translation, 'commissions.ba_label') + "*"}</Label>
                    <Col sm={8}>
                        <Select
                            selectedOption={_.find(options, option => option.value === this.state.baId)}
                            options={options}
                            onSelect={this.handleChangeBA}
                            isSearchable={false}
                            requiredFieldError={this.state.requiredFieldError === "baId"}
                        />
                    </Col>
                </FormGroup>
            );
        } else {
            let baData = _.find(this.props.BAsList, (elem) => elem.id === this.props.baId);
            return (
                <FormGroup row>
                    <Label sm={4}>{_.get(this.props.translation, 'commissions.ba_label') + "*"}</Label>
                    <Col sm={8}>
                        <Input
                            type='text'
                            value={baData ? baData.firstName + " " + baData.lastName : ""}
                            readOnly
                        />
                    </Col>
                </FormGroup>
            );
        }
    };

    renderContinentAndCountriesFormGroups = () => {
        let continentOptions = Utils.getLocationOptions(
            this.props.continents,
            _.get(this.props.translation, sharedLabelsPath.continents)
        );
        let selectedCountriesOptions = Utils.getLocationOptions(
            this.state.countries,
            _.get(this.props.translation, sharedLabelsPath.countries)
        );
        let countriesOptions = Utils.getLocationOptions(
            this.props.countries,
            _.get(this.props.translation, sharedLabelsPath.countries)
        );

        return [
            <FormGroup row key="continent">
                <Label sm={4}>{_.get(this.props.translation, sharedLabelsPath.continent_label) + "*"}</Label>
                <Col sm={8}>
                    <Select
                        selectedOption={_.find(continentOptions, option => option.value === this.state.continent)}
                        options={continentOptions}
                        onSelect={this.handleChangeContinent}
                        placeholder={_.get(this.props.translation, sharedLabelsPath.continent_input_placeholder)}
                        disabled={!this.props.continents}
                        requiredFieldError={this.state.requiredFieldError === "continent"}
                    />
                </Col>
            </FormGroup>,
            <FormGroup row key="countries">
                <Label sm={4}>{_.get(this.props.translation, "commissions.countries_label") + "*"}</Label>
                <Col sm={8}>
                    <Select
                        selectedOption={selectedCountriesOptions}
                        options={countriesOptions}
                        onSelect={this.handleChangeCountries}
                        placeholder={_.get(this.props.translation, sharedLabelsPath.country_input_placeholder)}
                        disabled={!this.props.countries}
                        requiredFieldError={this.state.requiredFieldError === "countries"}
                        isMulti
                        closeMenuOnSelect={false}
                    />
                </Col>
            </FormGroup>
        ];
    }

    renderCommissionFormGroup = () => {
        return (
            <FormGroup row>
                <Label sm={4}>{_.get(this.props.translation, 'commissions.commission_label') + " (%)*"}</Label>
                <Col sm={8}>
                    <Input
                        type="number"
                        min={0.1}
                        max={80}
                        step={0.1}
                        value={this.state.commission}
                        onChange={this.handleChangeCommission}
                        required
                        placeholder={_.get(this.props.translation, 'commissions.commission_label')}
                    />
                </Col>
            </FormGroup>
        );
    }

    renderPeriodFormGroups = () => {
        return [
            <FormGroup row key="date-from">
                <Label sm={4}>{_.get(this.props.translation, 'commissions.date_from_label') + "*"}</Label>
                <Col sm={8}>
                    <DatePicker
                        customInput={<Input />}
                        selected={this.state.dateFrom}
                        selectsStart
                        startDate={this.state.dateFrom}
                        endDate={this.state.dateTo}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        onChange={this.handleChangeDate("dateFrom")}
                        placeholderText={_.get(this.props.translation, 'commissions.date_from_label')}
                        minDate={moment()}
                        required
                    />
                </Col>
            </FormGroup>,
            <FormGroup row key="date-to">
                <Label sm={4}>{_.get(this.props.translation, 'commissions.date_to_label') + "*"}</Label>
                <Col sm={8}>
                    <DatePicker
                        customInput={<Input />}
                        selected={this.state.dateTo}
                        selectsEnd
                        startDate={this.state.dateFrom}
                        endDate={this.state.dateTo}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        onChange={this.handleChangeDate("dateTo")}
                        minDate={this.state.dateFrom}
                        placeholderText={_.get(this.props.translation, 'commissions.date_to_label')}
                        required
                    />
                </Col>
            </FormGroup>
        ];
    }

    handleChangeBA = (selectedOption) => {
        this.setState({ baId: selectedOption.value })
    }

    handleChangeCommission = (e) => {
        let commission = _.round(Number(e.target.value), 1);
        this.setState({ commission: commission });
    }

    handleChangeContinent = (selectedOption) => {
        this.setState({ countries: [] });
        this.props.onSetContinent(selectedOption.value);
    };

    handleChangeCountries = (selectedOptions) => {
        let countries = _.map(selectedOptions, (selectedOption) => selectedOption.value);
        this.setState({ countries: countries });
    }

    handleChangeDate = (fieldKey) => (date) => {
        this.setState({ [fieldKey]: date });
    };

    saveButtonDisabled = () => {
        if (this.props.actionType === ACTION_TYPES.ADD) {
            return false;
        }

        if (_.isNil(this.props.data)) {
            return true;
        }


        return _.every(fields, field => {
            if (field === 'dateFrom' || field === 'dateTo') {
                return moment(this.props.data[field]).format('L') === moment(this.state[field]).format('L');
            }

            if (field === 'countries') {
                return _.isEqual(_.sortBy(this.props.data[field]), _.sortBy(this.state[field]));
            }

            return this.props.data.hasOwnProperty(field) ? this.props.data[field] === this.state[field] : this.state[field] === '';
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        let data = {
            businessAmbassadorId: this.state.baId,
            countryCodes: this.state.countries,
            commissionPercent: this.state.commission,
            dateFrom: this.state.dateFrom.toISOString(),
            dateTo: this.state.dateTo.toISOString(),
        };

        switch (this.props.actionType) {
            case ACTION_TYPES.ADD:
                this.props.onProcess(this.state.baId, data);
                break;

            case ACTION_TYPES.EDIT:
                this.props.onProcess(this.props.baId, this.props.id, data);
                break;

            default:
                break;
        }
    };

    resetData = () => {
        this.setState({
            baId: '',
            continent: '',
            countries: [],
            commission: '',
            dateFrom: null,
            dateTo: null,
            requiredFieldError: null
        })
        this.props.onSetContinent('');
    };

    checkRequiredSelectFields = () => {
        let error = _.find(requiredSelectFields, field => {
            if (!this.state[field] || (field === "countries" && this.state.countries.length === 0)) {
                return field;
            }
        });
        this.setState({ requiredFieldError: error });
        return error;
    }
}

CommissionDetails.propTypes = {
    translation: PropTypes.object.isRequired,
    actionType: PropTypes.string.isRequired,
    id: PropTypes.string,
    baId: PropTypes.string,
    data: PropTypes.object,
    currentContinent: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    BAsList: PropTypes.array,
    loading: PropTypes.bool,
    success: PropTypes.bool,
    onProcess: PropTypes.func.isRequired,
    onGetBAsList: PropTypes.func,
    onSetContinent: PropTypes.func,
    onUnmount: PropTypes.func
};

export default CommissionDetails;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/commissionDetails/CommissionDetails.js